// Platzbewertung nur aus echten Bewertungen; die offizielle Sterne-Klassifizierung (OSM `stars`) ist eine eigene Angabe.
// Zwilling: lib/rating.js (Gleichheit per Test).
export function userRating(s) {
  const r = Number(s && s.rating), n = Number(s && s.review_count);
  return n > 0 && r > 0 ? r : null;
}
export function classStars(s) {
  const n = Number(s && s.stars);
  return Number.isInteger(n) && n >= 1 && n <= 5 ? n : null;
}

// ── Darstellung: zwei Arten von Sternen, überall dieselben Zeichen (2026-10-21) ──
// Bewertung der Camper = gefüllter Stern + Zahl (+ Anzahl), nie ein Chip.
// Klassifizierung wie bei Hotels = grauer Chip mit dem Hotelsterne-Symbol, ganze Zahl, nie der Bewertungsstern.
// o: { t(key, vars), esc(text), fmt(zahl) → Zahl mit höchstens einer Nachkommastelle, tip: 'data' | 'title',
//      size: 's' | 'l', countText (nur 'l'), btn: Attribut-Text (fest im Code) → das Element wird ein Knopf }
function badgeOpen(cls, tipKey, o) {
  const tip = `${o.tip === 'title' ? 'title' : 'data-tip'}="${o.esc(o.t(tipKey))}"`;
  return o.btn ? `<button type="button" class="${cls}" ${tip} ${o.btn}>` : `<span class="${cls}" ${tip}>`;
}
function starRow(r) {
  let s = '';
  for (let i = 1; i <= 5; i++) s += `<span class="vc-icon${r >= i - 0.25 ? ' is-on' : ''}" aria-hidden="true">${r >= i - 0.75 && r < i - 0.25 ? 'star_half' : 'star'}</span>`;
  return `<span class="vc-stars" aria-hidden="true">${s}</span>`;
}
export function userRatingHtml(s, o) {
  const r = userRating(s);
  if (!r) return '';
  const big = o.size === 'l';
  const count = big && o.countText ? o.countText : `(${o.fmt(Number(s.review_count))})`;
  return badgeOpen('vc-urating' + (big ? ' is-l' : ''), 'ui.rate_user_tip', o)
    + `<span class="vc-visually-hidden">${o.esc(o.t('ui.rate_user'))}: </span>`
    + (big ? starRow(r) : '<span class="vc-icon vc-star" aria-hidden="true">star</span>')
    + `<span class="vc-urating-n">${o.esc(o.fmt(r))}</span> <span class="vc-urating-c">${o.esc(count)}</span>`
    + (o.btn ? '</button>' : '</span>');
}
export function classHtml(n, o) {
  const c = classStars({ stars: n });
  if (!c) return '';
  return badgeOpen('vc-tag vc-class', 'ui.rate_class_tip', o)
    + `<span class="vc-icon" aria-hidden="true">hotel_class</span>${o.esc(o.t('ui.rate_class', { n: c }))}`
    + (o.btn ? '</button>' : '</span>');
}
/** Inhalt der Erklärung „Zwei Arten von Sternen“ — beide nebeneinander, mit denselben Zeichen wie in der Anzeige.
 *  o.spot: Beispielwerte des Platzes (sonst 4,6 und 3 Sterne). */
export function ratingExplainHtml(o) {
  const sp = o.spot || {};
  const row = (sample, title, text) => `<div class="vc-rate-row"><div class="vc-rate-sample" aria-hidden="true">${sample}</div><div><strong>${o.esc(o.t(title))}</strong><p>${o.esc(o.t(text))}</p></div></div>`;
  return `<div class="vc-rate-explain">`
    + row(`<span class="vc-urating"><span class="vc-icon vc-star" aria-hidden="true">star</span><span class="vc-urating-n">${o.esc(o.fmt(userRating(sp) || 4.6))}</span></span>`, 'ui.rate_user', 'ui.rate_user_text')
    + row(`<span class="vc-tag vc-class"><span class="vc-icon" aria-hidden="true">hotel_class</span>${o.esc(o.t('ui.rate_class', { n: classStars(sp) || 3 }))}</span>`, 'ui.rate_class_title', 'ui.rate_class_text')
    + '</div>';
}
